import { render, staticRenderFns } from "./StandardItem.vue?vue&type=template&id=ce48d6aa&scoped=true&"
import script from "./StandardItem.vue?vue&type=script&lang=js&"
export * from "./StandardItem.vue?vue&type=script&lang=js&"
import style0 from "./StandardItem.vue?vue&type=style&index=0&id=ce48d6aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce48d6aa",
  null
  
)

export default component.exports